export const FailedAgreementIcon = ({
  strokeColor = "var(--color-red)",
  ...props
}: any) => (
  <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
    <path
      d="M49.9987 94.7913C25.2904 94.7913 5.20703 74.708 5.20703 49.9997C5.20703 25.2913 25.2904 5.20801 49.9987 5.20801C74.707 5.20801 94.7904 25.2913 94.7904 49.9997C94.7904 74.708 74.707 94.7913 49.9987 94.7913ZM49.9987 11.458C28.7487 11.458 11.457 28.7497 11.457 49.9997C11.457 71.2497 28.7487 88.5413 49.9987 88.5413C71.2487 88.5413 88.5404 71.2497 88.5404 49.9997C88.5404 28.7497 71.2487 11.458 49.9987 11.458Z"
      fill={strokeColor}
    />
    <path
      d="M38.2083 64.9167C37.4167 64.9167 36.625 64.625 36 64C34.7917 62.7917 34.7917 60.7917 36 59.5833L59.5833 36C60.7917 34.7917 62.7917 34.7917 64 36C65.2083 37.2083 65.2083 39.2083 64 40.4167L40.4167 64C39.8333 64.625 39 64.9167 38.2083 64.9167Z"
      fill={strokeColor}
    />
    <path
      d="M61.7917 64.9167C61 64.9167 60.2083 64.625 59.5833 64L36 40.4167C34.7917 39.2083 34.7917 37.2083 36 36C37.2083 34.7917 39.2083 34.7917 40.4167 36L64 59.5833C65.2083 60.7917 65.2083 62.7917 64 64C63.375 64.625 62.5833 64.9167 61.7917 64.9167Z"
      fill={strokeColor}
    />
  </svg>
);
